import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Clients from '@/pages/Clients';
import Contact from '@/pages/Contact';
import Portfolio from '@/pages/Portfolio';
import Project from '@/pages/Project';
import NavBar from '@/components/NavBar';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients,
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      component: Portfolio,
    },
    {
      path: '/portfolio/:project',
      name: 'project',
      component: Project
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/navbar',
      name: 'navbar',
      component: NavBar,
    },
    {
      path: '*',
      name: 'CatchAll',
      component: Home
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return{ x: 0, y: 0 }
  }
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
      // Start the route progress bar.
      NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router;